<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Шүүлтүүр
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row class="d-flex align-items-center justify-content-end">
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Эхлэх огноо</label>
          <flat-pickr v-model="start_date" class="form-control"
                    :config="{ enableTime: true, dateFormat: 'Y-m-d H:i:m' }"/>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Дуусах огноо</label>
          <!-- <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="planFilter"
            :options="planOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:planFilter', val)"
          /> -->
          <flat-pickr v-model="end_date" class="form-control"
                    :config="{ enableTime: true, dateFormat: 'Y-m-d H:i:m'}"/>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Тайлангийн нэр</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            v-model="report_name"
            :options="reportNameOptions"
            class="w-100"
            label="name"
            :reduce="val => val.name"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <b-button
            variant="primary"
            @click="$emit('update:reportFilter', { start_date, end_date, report_name })"
            class="_report_submit_button"
          >
            <span class="text-nowrap">Тайлан татах</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BButton
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    flatPickr
  },
  watch: {
    'reportNameOptions'() {
      this.setReportName()
    }
  },
  props: {
    reportNameOptions: {
      type: Array,
      required: true,
    },
    reportFilter: {
      type: Object,
      default: null,
    }
  },
  data () {
    let today = new Date()
    return {
      start_date: '',
      end_date:  '',
      report_name: ''
    }
  },
  methods: {
    setReportName() {
      let hours = (new Date()).getHours() <= 8 ? 8 : (new Date()).getHours()
      if (this.reportNameOptions.length > 0) {
        this.report_name = this.reportNameOptions[0].name
        this.start_date = new Date(new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate(), 0, 0, 0).setHours(8))
        this.end_date = new Date(new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate(), 0, 59, 59).setHours(hours))
      }
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style scoped>
  ._report_submit_button {
    margin-top: 19px;
  }
</style>
